<template>
    <div class="input-group input-group-sm col">
        <div class="input-group-prepend">
            <div class="input-group-text">
                {{ text }}
            </div>
        </div>
        <select
            v-model="selected"
            @change="$emit('change', $event.target.value)"
            class="custom-select custom-select-sm"
        >
            <option
                v-for="(value, index) in values"
                :key="index"
            >
                {{ value }}
            </option>
        </select>
        <div class="input-group-append" />
        <slot />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
})
export default class DropDownComponent extends Vue {
    @Prop()
    private text: any;

    @Prop()
    private values: any;

    @Prop()
    private selected: any;
}
</script>
<style lang="less" >
</style>
